<template>
    <section id="sec-3">
        <div class="container">
            <div class="caption">
                <h2>ВЫПЛАТЫ ВЕБ-МАСТЕРУ</h2>
            </div>
            <img src="../../assets/sap-s-3_1.png" class="sap-1" v-if="!isMobyle">
            <div class="grid">
                <div class="grid__coll button" :class="{ active: selectedBlock == 1 }" @click="selectedBlock = 1">
                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.75 21.3333H44.25M15.0833 31.75H15.1042M23.4167 31.75H27.5833M6.75 17.1666C6.75 15.509 7.40848 13.9193 8.58058 12.7472C9.75269 11.5751 11.3424 10.9166 13 10.9166H38C39.6576 10.9166 41.2473 11.5751 42.4194 12.7472C43.5915 13.9193 44.25 15.509 44.25 17.1666V33.8333C44.25 35.4909 43.5915 37.0806 42.4194 38.2527C41.2473 39.4248 39.6576 40.0833 38 40.0833H13C11.3424 40.0833 9.75269 39.4248 8.58058 38.2527C7.40848 37.0806 6.75 35.4909 6.75 33.8333V17.1666Z"
                            stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>БАНКОВСКИЕ КАРТЫ</span>
                </div>
                <div class="grid__coll button" :class="{ active: selectedBlock == 2 }" @click="selectedBlock = 2">
                    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.25 25.5C6.25 27.9623 6.73498 30.4005 7.67726 32.6753C8.61953 34.9502 10.0006 37.0172 11.7417 38.7582C13.4828 40.4993 15.5498 41.8805 17.8247 42.8227C20.0995 43.765 22.5377 44.25 25 44.25C27.4623 44.25 29.9005 43.765 32.1753 42.8227C34.4502 41.8805 36.5172 40.4993 38.2582 38.7582C39.9993 37.0172 41.3805 34.9502 42.3227 32.6753C43.265 30.4005 43.75 27.9623 43.75 25.5C43.75 23.0377 43.265 20.5995 42.3227 18.3247C41.3805 16.0498 39.9993 13.9828 38.2582 12.2417C36.5172 10.5006 34.4502 9.11953 32.1753 8.17726C29.9005 7.23498 27.4623 6.75 25 6.75C22.5377 6.75 20.0995 7.23498 17.8247 8.17726C15.5498 9.11953 13.4828 10.5006 11.7417 12.2417C10.0006 13.9828 8.61953 16.0498 7.67726 18.3247C6.73498 20.5995 6.25 23.0377 6.25 25.5Z"
                            stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M18.75 17.1667H27.2708C29.4687 17.1667 31.25 19.0313 31.25 21.3334C31.25 23.6355 29.4687 25.5 27.2708 25.5C29.4687 25.5 31.25 27.3646 31.25 29.6667C31.25 31.9688 29.4687 33.8334 27.2708 33.8334H18.75M20.8333 25.5H29.1667M20.8333 15.0834V35.9167V17.1667M27.0833 15.0834V17.1667M27.0833 33.8334V35.9167"
                            stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <span>КРИПТОВАЛЮТЫ</span>
                </div>
                <div class="grid__coll button" :class="{ active: selectedBlock == 3 }" @click="selectedBlock = 3">
                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M35.9166 17.1667V10.9167C35.9166 10.3642 35.6971 9.83427 35.3064 9.44357C34.9157 9.05287 34.3858 8.83337 33.8333 8.83337H12.9999C11.8948 8.83337 10.835 9.27236 10.0536 10.0538C9.27224 10.8352 8.83325 11.895 8.83325 13M8.83325 13C8.83325 14.1051 9.27224 15.1649 10.0536 15.9463C10.835 16.7277 11.8948 17.1667 12.9999 17.1667H37.9999C38.5525 17.1667 39.0824 17.3862 39.4731 17.7769C39.8638 18.1676 40.0833 18.6975 40.0833 19.25V25.5M8.83325 13V38C8.83325 39.1051 9.27224 40.1649 10.0536 40.9463C10.835 41.7277 11.8948 42.1667 12.9999 42.1667H37.9999C38.5525 42.1667 39.0824 41.9472 39.4731 41.5565C39.8638 41.1658 40.0833 40.6359 40.0833 40.0834V33.8334"
                            stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M42.1665 25.5V33.8333H33.8332C32.7281 33.8333 31.6683 33.3943 30.8869 32.6129C30.1055 31.8315 29.6665 30.7717 29.6665 29.6667C29.6665 28.5616 30.1055 27.5018 30.8869 26.7204C31.6683 25.939 32.7281 25.5 33.8332 25.5H42.1665Z"
                            stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>ЭЛЕКТРОННЫЕ КОШЕЛЬКИ</span>
                </div>
                <div class="grid__coll join"
                    :class="{ left: selectedBlock == 1, center: selectedBlock == 2, right: selectedBlock == 3 }">
                    <div class="wrapp">

                    </div>
                </div>
                <div class="grid__coll place">
                    <template v-if="selectedBlock == 1">
                        <svg width="233" height="40" viewBox="0 0 233 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M19.505 8.62339L18.515 11.3444L14.07 23.5574L13.489 20.5224L11.543 10.4564C11.208 9.06839 10.232 8.65639 9.027 8.60839H0.0730019L0 9.06139C2.178 9.62939 4.125 10.4484 5.832 11.4644L10.77 30.4904L16.645 30.4874L18.515 25.8124L25.388 8.62239H19.505V8.62339ZM27.635 8.60439L27.545 9.17039L24.162 30.5104H29.715L31.035 22.1744L33.188 8.60439H27.635ZM61.855 22.7434C61.428 20.6351 60.9993 18.5271 60.569 16.4194L60.196 14.5304C59.916 15.3514 59.426 16.6784 59.456 16.6204C59.456 16.6204 57.706 21.4844 57.246 22.7434H61.855ZM68.589 30.5184H63.435C63.435 30.5184 62.925 28.0004 62.759 27.2354C61.949 27.2354 56.284 27.2244 55.648 27.2244L55.501 27.6344C55.161 28.5864 54.481 30.5184 54.481 30.5184H48.65L55.5 13.8354L56.895 10.4424C57.478 9.01439 58.475 8.62639 59.805 8.62639H64.095L68.589 30.5184ZM49.048 23.3524C49.014 26.8684 46.731 29.4144 43.002 30.3924C41.8181 30.6938 40.6006 30.8427 39.379 30.8354C39.197 30.8324 39.017 30.8224 38.836 30.8154C36.545 30.7234 34.394 30.2334 33.193 29.6674L33.971 24.7644L34.685 25.1124C36.189 25.7864 37.263 26.1254 38.835 26.2254C39.171 26.2474 39.523 26.2614 39.915 26.2614C41.171 26.2614 42.485 25.8374 43.002 24.9434C43.1515 24.6953 43.2325 24.412 43.237 24.1224C43.2401 23.8283 43.1585 23.5395 43.002 23.2904C42.647 22.7014 41.849 22.1444 40.355 21.4044C39.8343 21.148 39.327 20.8653 38.835 20.5574C37.115 19.4724 35.466 17.8764 35.493 15.4524C35.511 13.0424 36.761 11.0444 38.836 9.76439C39.99 9.05139 41.402 8.56339 43.002 8.34839C43.602 8.26839 44.227 8.22339 44.878 8.22339C47.028 8.22339 48.755 8.70239 49.853 9.14239L49.102 13.8914L48.602 13.6414C47.578 13.1954 46.264 12.7684 44.448 12.7984C43.888 12.7984 43.408 12.8654 43.002 12.9764C41.826 13.2984 41.268 14.0084 41.267 14.6834C41.257 15.4364 41.898 16.0004 43.002 16.6464C43.405 16.8824 43.865 17.1284 44.384 17.4004C47.588 18.9634 49.068 20.8564 49.048 23.3524Z"
                                fill="#FEFEFE" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M201.587 23.773H203.407L203.967 20.739C204.504 18.756 205.367 18.895 205.811 18.895L206.278 17.145C205.368 17.145 204.831 17.472 204.551 17.798L204.388 17.145H202.824L201.587 23.773ZM215.726 20.786C215.422 20.739 214.746 20.552 214.161 20.949C213.578 21.346 213.415 22.046 214.021 22.279C214.606 22.505 215.468 22.117 215.585 21.509L215.726 20.786ZM212.925 17.262L212.645 18.709C213.088 18.662 214.278 18.476 214.909 18.499C215.539 18.522 216.239 18.429 216.029 19.432C215.562 19.479 212.294 18.965 211.781 21.766C211.571 23.144 212.761 23.844 213.695 23.797C214.628 23.75 214.885 23.633 215.212 23.4L215.446 23.773H217.149L217.873 20.133C218.06 19.223 218.363 17.028 215.305 17.028C214.745 17.051 214.115 17.028 212.925 17.262ZM226.485 20.576C226.672 19.969 226.57 19.211 226.368 18.942C225.808 18.195 224.52 18.786 224.128 20.249C223.871 21.206 224.432 21.929 225.062 21.929C225.739 21.929 226.158 21.393 226.485 20.576ZM227.139 17.845C226.789 17.588 226.579 17.051 225.715 17.051C224.712 17.051 223.147 16.865 222.261 19.899C221.668 21.927 222.867 23.773 224.174 23.773C224.781 23.75 225.388 23.493 225.761 23.236L225.995 23.773H227.955L229.543 15.278H227.629L227.139 17.845ZM211.618 17.565L212.808 16.375C212.341 15.861 211.804 15.356 210.31 15.301C209.05 15.254 206.89 16.174 206.203 18.685C205.269 22.093 207.323 23.773 209.213 23.773C210.217 23.773 210.824 23.633 211.431 23.353L210.894 21.72C209.027 22.35 207.696 21.393 208 19.456C208.256 17.818 209.61 17.238 210.217 17.238C210.824 17.238 211.152 17.285 211.618 17.565ZM184.917 20.786C184.613 20.739 183.936 20.552 183.352 20.949C182.769 21.346 182.606 22.046 183.212 22.279C183.797 22.505 184.659 22.117 184.776 21.509L184.917 20.786ZM182.115 17.262L181.835 18.709C182.279 18.662 183.469 18.476 184.099 18.499C184.729 18.522 185.43 18.429 185.219 19.432C184.753 19.479 181.485 18.965 180.972 21.766C180.762 23.144 181.952 23.844 182.885 23.797C183.819 23.75 184.075 23.633 184.403 23.4L184.637 23.773H186.34L187.064 20.133C187.251 19.223 187.554 17.028 184.496 17.028C183.936 17.051 183.305 17.028 182.115 17.262ZM180.108 23.773L181.626 15.698H178.638L176.42 20.599L176.07 15.698H173.153L171.589 23.773H173.409L174.529 17.939L175.019 23.773H176.747L179.291 18.079L178.217 23.773H180.108ZM191.918 18.639L192.338 17.285C191.475 16.958 190.798 17.028 190.541 17.028C190.284 17.028 188.099 17.001 187.764 18.616C187.507 19.852 187.96 20.365 188.394 20.552C189.094 20.856 189.491 21.136 189.864 21.323C190.327 21.554 190.242 22.326 189.631 22.326C189.351 22.326 188.137 22.466 187.227 22.163L186.97 23.54C187.81 23.773 188.487 23.773 189.118 23.773C189.561 23.773 191.732 23.891 192.035 21.883C192.183 20.904 191.755 20.459 191.405 20.249C191.055 20.015 190.471 19.689 190.098 19.525C189.724 19.362 189.444 18.732 190.121 18.545C190.541 18.498 191.404 18.498 191.918 18.639ZM197.683 19.573H199.948C200.064 18.919 199.854 18.359 199.131 18.359C198.407 18.359 197.894 18.732 197.683 19.573ZM201.535 20.786C201.745 19.712 202.235 17.051 199.038 17.051C196.096 17.051 195.723 19.969 195.653 20.389C195.583 20.809 195.536 23.773 198.687 23.773C199.457 23.797 200.577 23.703 201.022 23.47L201.302 22.093C201.022 22.163 199.971 22.256 199.247 22.256C198.523 22.256 197.357 22.303 197.567 20.786H201.535ZM193.645 15.371L192.385 21.72C192.035 23.54 193.412 23.797 193.832 23.797C194.252 23.797 194.789 23.727 195.186 23.47L195.303 22.117C194.253 22.28 194.206 21.813 194.299 21.299L194.813 18.592H195.746L196.073 17.145H195.093L195.466 15.371H193.645ZM217.856 23.769H219.695L220.261 20.704C220.803 18.7 221.652 18.817 222.1 18.817L222.595 17.073C221.675 17.073 221.133 17.403 220.85 17.733L220.685 17.073H219.105L217.856 23.769ZM231.155 19.529C231.155 9.53602 223.053 1.43502 213.06 1.43502C208.905 1.42549 204.875 2.86074 201.662 5.49502C204.039 7.79102 205.854 10.665 206.827 13.912H205.324C204.387 11.0627 202.755 8.4918 200.575 6.43202C198.409 8.49474 196.789 11.0619 195.858 13.904H194.354C195.314 10.7156 197.074 7.82571 199.466 5.50902C196.357 2.99102 192.43 1.43502 188.118 1.43502C178.125 1.43502 170.024 9.53502 170.024 19.529C170.024 29.522 178.125 37.623 188.118 37.623C192.43 37.623 196.358 36.067 199.466 33.549C197.074 31.2325 195.314 28.3425 194.354 25.154H195.858C196.789 27.9961 198.409 30.5633 200.575 32.626C202.755 30.5664 204.387 27.9955 205.324 25.146H206.827C205.854 28.394 204.039 31.267 201.662 33.562C204.875 36.1967 208.905 37.6323 213.06 37.623C223.053 37.623 231.155 29.522 231.155 19.529ZM232.589 19.529C232.589 30.315 223.846 39.059 213.06 39.059C208.512 39.0656 204.106 37.4783 200.607 34.573C197.223 37.386 192.863 39.058 188.118 39.058C177.333 39.058 168.589 30.315 168.589 19.53C168.589 8.74502 177.333 2.18702e-05 188.119 2.18702e-05C192.863 2.18702e-05 197.223 1.67202 200.607 4.48502C204.106 1.58015 208.512 -0.00679494 213.06 2.18702e-05C223.846 2.18702e-05 232.59 8.74302 232.59 19.53L232.589 19.529Z"
                                fill="white" />
                        </svg>

                    </template>
                    <template v-else-if="selectedBlock == 2">
                        <span>Tether TRC 20, Tether ERC 20, TRON, Ethereum, Binance Coin, Bitcoin Cash, Cardano, XRP,
                            Dogecoin</span>
                    </template>
                    <template v-else-if="selectedBlock == 3">
                        <span>Jeton wallet</span>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'Section3Com',
    computed: {
        ...mapState({
            windowWidth: state => state.windowWidth,
        }),
        isMobyle() {
            return this.windowWidth <= 560
        },
        isTablet() {
            return this.windowWidth <= 768
        },
        link() {
            return 'https://sapphirebet.partners/sign-up/' + window.location.search
        }
    },
    data() {
        return {
            selectedBlock: 1,
        }
    }
}
</script>
<style lang="scss">
#sec-3 {
    padding: 0 20px;
    position: relative;
    z-index: 5;
    padding-top: 244px;

    @media screen and (max-width: 576px) {
        padding-top: 120px;
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 20px;
        position: relative;
        z-index: 2;

        @media screen and (max-width: 576px) {
            grid-template-columns: repeat(3, calc(33.333% - 7.5px));
            column-gap: 15px;
        }

        &__coll {
            display: flex;
            flex-direction: column;
            gap: 30px;
            align-items: center;

            @media screen and (max-width: 576px) {
                gap: 15px;
            }

            &.button {
                cursor: pointer;
                border-radius: 20px;
                background: #0F195E;
                padding: 30px;
                transition: all .3s;

                &.active {
                    background: #172B9B;
                }

                svg {
                    @media screen and (max-width: 576px) {
                        width: 50px;
                        height: 50px;
                    }
                }
            }

            &.join {
                grid-row: 2;
                grid-column: 1/4;
                height: 20px;
                display: flex;
                flex-direction: row;
                padding: 0 8vw;

                @media screen and (max-width: 768px) {
                    padding: 0 6.5vw;
                }

                @media screen and (max-width: 576px) {
                    padding: 0 5vw;
                }

                $r: 10px;

                &.left {
                    justify-content: flex-start;
                }

                &.center {
                    justify-content: center;
                }

                &.right {
                    justify-content: flex-end;
                }

                .wrapp {
                    transition: all .3s;
                    width: 204px;
                    overflow: hidden;
                    position: relative;
                    max-width: 204px;
                    min-height: 20px;
                    border-radius: 1em;

                    @media screen and (max-width: 768px) {
                        width: 120px;
                        max-width: 120px;
                    }

                    @media screen and (max-width: 576px) {
                        width: 80px;
                        max-width: 80px;
                    }

                    &:before {
                        position: absolute;
                        margin: 0;
                        padding: $r;
                        border-radius: 50%;
                        box-shadow: 0 0 0 150px rgba(#172B9B, 1);
                        content: '';
                        left: 0%;

                        @media screen and (max-width: 768px) {
                            box-shadow: 0 0 0 60px rgba(#172B9B, 1);
                        }

                        @media screen and (max-width: 576px) {
                            box-shadow: 0 0 0 40px rgba(#172B9B, 1);
                        }
                    }

                    &::after {
                        position: absolute;
                        margin: 0;
                        padding: $r;
                        border-radius: 50%;
                        box-shadow: 0 0 0 150px rgba(#172B9B, 1);
                        content: '';
                        left: 90%;

                        @media screen and (max-width: 768px) {
                            box-shadow: 0 0 0 60px rgba(#172B9B, 1);
                            left: 85%;
                        }

                        @media screen and (max-width: 576px) {
                            box-shadow: 0 0 0 40px rgba(#172B9B, 1);
                            left: 75%;
                        }
                    }

                }
            }

            &.place {
                grid-row: 3;
                grid-column: 1/4;
                border-radius: 20px;
                background: #172B9B;
                padding: 55px 0;

                span {
                    color: #FFF;
                    text-align: center;
                    font-size: 25px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    display: inline-block;
                    max-width: 60%;

                    @media screen and (max-width: 576px) {
                        font-size: 16px;
                    }
                }
            }

            span {
                color: #FFF;
                text-align: center;
                font-size: 25px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;

                @media screen and (max-width: 768px) {
                    font-size: 15px;
                }

                @media screen and (max-width: 576px) {
                    font-size: 10px;
                }
            }
        }
    }

    .sap-1 {
        position: absolute;
        left: -20px;
        z-index: 1;
        top: 20vw;
    }
}
</style>
  